export enum GTMEventName {
  // Signup & Verification
  CREDENTIALS_SIGNUP = 'credentials_signup',
  GOOGLE_SIGNUP = 'google_signup',
  PHONE_NUMBER_VERIFIED = 'phone_number_verified',
  IDENTITY_VERIFICATION_COMPLETED = 'identity_verification_completed',
  COMPANY_ADDED = 'company_added',

  // Onboarding
  FINANCIAL_DOCUMENTS_UPLOADED = 'financial_documents_uploaded',
  SIGNATORY_INVITED = 'signatory_invited',
  SIGNATORY_OR_UBO_INVITED = 'signatory_or_ubo_invited',
  POA_REQUEST_SENT = 'poa_request_sent',
  POA_DOCUMENT_SIGNED = 'poa_document_signed',
  UBO_INVITED = 'ubo_invited',
  KYC_SUBMITTED = 'kyc_submitted',

  // Orders
  PAYABLE_ORDER_CREATED = 'payable_order_created',
  FIRST_PAYABLE_ORDER_CREATED = 'first_payable_order_created',
  PAYABLE_ORDER_SIGNED = 'payable_order_signed',
  FIRST_PAYABLE_ORDER_SIGNED = 'first_payable_order_signed',
  PAYABLE_MULTIPLE_ORDERS_SIGNED = 'payable_multiple_orders_signed',
  RECEIVABLE_ORDER_CREATED = 'receivable_order_created',
  FIRST_RECEIVABLE_ORDER_CREATED = 'first_receivable_order_created',
  RECEIVABLE_ORDER_SIGNED = 'receivable_order_signed',
  FIRST_RECEIVABLE_ORDER_SIGNED = 'first_receivable_order_signed',
  RECEIVABLE_MULTIPLE_ORDERS_SIGNED = 'receivable_multiple_orders_signed',
}

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;
